import { useState, useEffect } from 'react';

const PaginatedDropdown = ({
  fetchFn, // API function to call
  responseKey, // e.g., "accountList" or "contactList"
  defaultSearch = '', // initial search value
  pageSize = 50, // items per page
  autoFetch = true, // fetch on mount or not
  module,
}) => {
  const [options, setOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState(defaultSearch);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async (search = '', pageNo = 1) => {
    setIsLoading(true);

    try {
      const res = await fetchFn({
        searchText: search,
        pageNumber: pageNo,
        pageSize,
        ...(module && { module: module }),
      });

      const newList = res?.data?.[responseKey] || [];
      const total = res?.data?.totalCount || 0;

      if (pageNo === 1) {
        setOptions(newList);
      } else {
        setOptions((prev) => [...prev, ...newList]);
      }

      setTotalCount(total);
    } catch (error) {
      console.error('Dropdown fetch error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (input) => {
    setSearchTerm(input);
    setPage(1);
    fetchData(input, 1);
  };

  const handleScroll = () => {
    const loaded = options.length;
    if (loaded < totalCount && !isLoading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchData(searchTerm, nextPage);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchData(defaultSearch, 1);
    }
  }, []);

  return {
    options,
    isLoading,
    handleSearch,
    handleScroll,
  };
};

export default PaginatedDropdown;
